const al = {
  // Navigation and Home Page
  work_place: "Vende pune",
  company: "E Ardhmja Juaj Nis Këtu",
  home_title: "Pse të zgjidhni TIA-n?",
  Join: "Aeroporti Ndërkombëtar i Tiranës",

title1: "Mjedis dinamik me ritëm të shpejtë dhe role të larmishme në aviacion",
title2: "Mundësi zhvillimi përmes trajnimeve, promovimeve të brendshme dhe rritjes profesionale",
title3: "Kulturë përfshirëse me një atmosferë bashkëpunuese dhe mbështetëse",
title4: "Stabilitet dhe ndikim në një institucion me rëndësi të veçantë kombëtare dhe ndërkombëtare ",

All: "Te gjitha",


reason1: "Role me ritëm të shpejtë dhe të larmishëm në aviacion.",
reason2: "Trajnim, promovime të brendshme dhe zhvillim profesional.",
reason3: "Një atmosferë ekipi bashkëpunuese dhe mbështetëse.",
reason4: "Punoni në një institucion të rëndësishëm në nivel kombëtar dhe të lidhur globalisht.",


  home_subtitle:
    "Në Tirana International Airport (TIA), ne jemi gjithmonë në kërkim të profesionistëve të talentuar për t'iu bashkuar ekipit tonë.",

  how_to_apply: "Si të aplikoni",

  how_to_apply_steps: [
    "Kontrolloni pozicionet e hapura më poshtë",
    "Plotësoni me saktësi formularin e aplikimit me të gjitha të dhënat e kërkuara",
    {
      bold:"Ngarkoni CV-në tuaj dhe dorëzoni aplikimin",
      normal:"(Vetëm nëpërmjet linkut - nuk pranohen aplikime fizike.)"
    },
    "Dorëzoni aplikimin brenda afatit të përcaktuar; aplikimet e vonuara nuk do të merren parasysh",
    {
      bold:" Vetëm kandidatët e përzgjedhur do të kontaktohen për hapat e mëtejshëm",
      normal:"(Nëse nuk kontaktoheni, CV-ja juaj ruhet në bazën tonë të të dhënave për pozicione të ardhshme)"
    },
  ],

  // Home Page Sections
  open_positions: "Pozicione të Hapura",
  why_join_tia: "Pse të bëheni pjesë e TIA?",
  reason_dynamic_environment:
    "Bëhuni pjesë e një ambienti pune dinamik dhe profesional.",
  reason_skills_development:
    "Zhvilloni aftësitë tuaja nëpërmjet të mësuarit të vazhdueshëm dhe mundësive të trajnimit.",
  reason_contribute_growth:
    "Kontribuoni në rritjen dhe suksesin e aeroportit kryesor të Shqipërisë.",

  sence_title: "Jeta prapa skenave në TIA",
  sence_text:
    "Nga pista e fluturimit deri te terminali, çdo rol në TIA ka rëndësi. Zbuloni se si është të jesh pjesë e një ekipi që e bën udhëtimin ajror të qetë, të sigurt dhe mikpritës.",
  apply_now: "Apliko tani",
  Department: "Departamenti",
  Availability: "Lloji i Punësimit",
  Location: "Vendndodhja",

  // Job Details Page
  apply: "Apliko",
  job_description_intro:
    "Tirana International Airport SHPK (TIA) kërkon të punësojë një {jobTitle}, që do të raportojë te {reportsToPositionFormat} i kompanisë.",
  application_deadline: "Afati i aplikimit:",
  main_duties_responsibilities:
    "Detyrat dhe përgjegjësitë kryesore të pozicionit:",
  position_requirements: "Kërkesat e pozicionit:",
  education: "Arsimi:",
  work_experience: "Eksperienca e punës:",
  language_requirements: "Kërkesat gjuhësore:",
  skills_competencies: "Aftësi dhe Kompetenca:",
  application_procedure: "Procedura e Aplikimit",
  application_procedure_text:
    "Plotësoni formularin e aplikimit me të gjithë informacionin e kërkuar. Departamenti i Burimeve Njerëzore do të kontaktojë vetëm kandidatët e përzgjedhur pas shqyrtimit të dokumentacionit.",

  // Form Navigation
  back: "Kthehu",
  continue: "Vazhdo",
  submit_application: "Dërgo aplikimin",

  // Form Steps
  step_personal: "Informacione Personale",
  step_education: "Arsimi",
  step_experience: "Deklaratë",
  step_languages: "Gjuhët",
  step_skills: "Aftësitë",
  step_training: "Trajnime",
  step_extra: "Pyetje Shtesë",
  step_cover_letter: "Letër Motivimi",
  step_declaration: "Deklaratë",

  // Personal Information Form
  full_name: "Emri i plotë (ashtu siç është në ID/Pasaportë)",
  gender: "Gjinia",
  female: "Femër",
  male: "Mashkull",
  date_of_birth: "Data e lindjes",
  nationality: "Kombësia",
  contact_number: "Numri i kontaktit",
  email_address: "Adresa e emailit",
  name_surname: "Emër Mbiemër",



  no_positions_available: "Nuk ka pozicione të hapura",

  // Education Form
  highest_education_level: "Niveli më i lartë i arsimit të përfunduar",
  institution_name: "Emri i institucionit",
  field_of_study: "Fusha e studimit",
  graduation_year: "Viti i diplomimit",
  additional_certifications: "Certifikime shtesë",
  certifications_placeholder:
    "Certifikime shtesë (p.sh., Siguria e Aviacionit, Ndihmë e Parë, IATA)",

  // Work Experience Form
  employer_name: "Emri i punëdhënësit",
  job_title: "Titulli i punës",
  from: "Nga",
  to: "Deri",
  reason_for_leaving: "Arsyeja e largimit",
  main_responsibilities: "Përgjegjësitë kryesore",
  position_not_specified: "Pozicioni nuk është specifikuar",
  employer_not_specified: "Emri i punëdhënësit nuk është specifikuar",

  // Language Skills
  language_proficiency: "Aftësia gjuhësore",
  language: "Gjuha",
  level: "Niveli",
  select: "Zgjidhni",
  add_language: "+ Shto gjuhë",
  delete: "Fshi",

  // Language Levels
  basic: "Bazik",
  intermediate: "I mesëm",
  fluent: "I rrjedhshëm",
  native: "Amtare",

  // Computer Skills
  technical_other_skills: "Aftësitë teknike dhe të tjera",
  computer_skills: "Aftësitë kompjuterike",
  enter_skill_name: "Aftësi të tjera",

  
  ms_office: "MS Office Package (Word, Excel, PowerPoint, Outlook)",
  sap_erp: "SAP/ERP",
  customer_service: "Shërbim për klientët",
  team_work: "Puna në ekip",
  communication_skills: "Aftësi komunikimi",
  problem_solving: "Zgjidhja e problemeve",
  leadership: "Udhëheqje",
  airport_systems: "Sistemet e aeroportit",
  other_specify: "Tjetër (specifikoni)",

  // Training Form
  title: "Titulli",
  institution: "Institucioni",
  place_institution: "Vendos institucionin e arsimit",
  location: "Vendi",
  street_city: "Rruga, qyteti",
  year: "Viti",
  duration: "Kohëzgjatja",

  // Extra Questions
  relatives_at_tia:
    "Keni të afërm që punojnë për Tirana International Airport?",
  specify_relationship: "Specifikoni marrëdhënien",
  how_learned_about_position: "Si e morët informacionin për pozicionin vakant?",

  // Information Sources
  from_friend: "Nga një person që punon në TIA",
  from_tia_employee: "Nga website",
  from_newspaper: "Nga social media",
  from_internet: "Tjetër",

  //Nationalities

  shqiptar: "Shqiptar",
  italian: "Italian",
  grek: "Grek",
  turk: "Turk",
  gjerman: "Gjerman",
  francez: "Francez",
  spanjoll: "Spanjoll",
  rus: "Rus",
  kinez: "Kinez",
  japonez: "Japonez",
  amerikan: "Amerikan",
  kanadez: "Kanadez",
  brazilian: "Brazilian",
  arab: "Arab",
  indian: "Indian",
  korean: "Korean",
  suedez: "Suedez",
  norvegjez: "Norvegjez",
  zelandz: "Zelandës i Ri",
  select_nationality: "Zgjidhni kombësinë",

  //Education
  entry_level_education: "Shkollë 9-vjeçare e përfunduar",
  middle_level_education: "Shkollë e Mesme e përfunduar",
  vocational_education: "Shkollë Profesionale",
  high_level_education: "Diplomë Bachelor (BSc/BA)",
  higher_education_master: "Diplomë Masteri (MSc/MA)",
  higher_education_professional: "Master profesional",
  higher_education_phd: "Doktoraturë (PhD)",
  select_education: "Zgjidhni arsimin",

  //Language
  albanian_language: "Shqip",
  english_language: "Anglisht",
  italian_language: "Italisht",
  german_language: "Gjermanisht",
  french_language: "Frëngjisht",
  spanish_language: "Spanjisht",
  turkish_language: "Turqisht",
  greek_language: "Greqisht",
  russian_language: "Rusisht",
  chinese_language: "Kinezisht",
  japanese_language: "Japonisht",
  arabic_language: "Arabisht",
  portuguese_language: "Portugeze",
  serbian_language: "Serbisht",
  croatian_language: "Kroatisht",
  bosnian_language: "Boshnjakisht",
  macedonian_language: "Maqedonisht",
  romanian_language: "Rumanisht",
  bulgarian_language: "Bullgarisht",
  polish_language: "Polonisht",

  // Work Time Options
  full_time: "Kohë e plotë",
  seasonal: "Sezonal",
  internship: "Praktikë",

  // Declaration
  declaration: "Deklaratë",
  declaration_text:
    "Deklaroj këtu se informacioni i dhënë është i vërtetë dhe i plotë. Kuptoj se çdo deklaratë e rreme mund të çojë në diskualifikim ose ndërprerje.",
  data_protection_agreement:
    "Unë pajtohem me politikën e mbrojtjes së të dhënave dhe privatësisë së TIA-s.",
  verification_authorization:
    "Autorizoj verifikimin e të gjithë informacionit të dorëzuar.",
  full_name_declaration: "Emri i plotë",

  // Cover Letter
  cover_letter_placeholder: "Shkruaj letër motivimi",
  why_work_for_tia: "Përse deshironi të punoni për TIA-n?",

  // Summary Page
  summary: "Përmbledhje",
  date_of_birth_label: "Data e lindjes:",
  address_residence: "Adresa e banimit:",
  gender_label: "Gjinia:",
  interest_for_work: "Interesi për punë",
  position_applied_for: "Pozicioni për të cilin aplikohet:",
  employment_type_desired: "Lloji i punësimit të dëshiruar:",
  education_background: "Arsimi",
  additional_certifications_label: "Certifikime shtesë:",
  work_experience_section: "Eksperienca e punës",
  responsibilities: "Përgjegjësitë:",
  reason_for_leaving_label: "Arsyeja e largimit:",
  computer_programs: "Programet kompjuterike",
  languages_section: "Gjuhët",
  additional_questions: "Pyetje shtesë",
  relatives_at_tia_question: "A keni të afërm që punojnë aktualisht në TIA?",
  specify_relatives: "Specifikoni të afërmit:",
  how_learned_vacancy: "Si e mësuat për vendin e lirë?",

  // Common Options
  yes: "Po",
  no: "Jo",

  // Validation Messages
  email_must_contain_at: "Emaili duhet të përmbajë simbolin '@'.",
  phone_minimum_digits: "Numri i telefonit duhet të ketë të paktën 9 shifra.",
  only_numbers_allowed: "Lejohen vetëm numrat.",
  date_cannot_be_future: "Data nuk mund të jetë në të ardhmen.",
  max_length_error: "Maximum length is {{count}} characters",

  // Error Messages
  error_fetching_jobs: "Gabim gjatë marrjes së listës së punëve:",
  error_fetching_form_model: "Gabim gjatë marrjes së modelit të formularit:",

  // Placeholders
  enter_phone_number: "Shkruani numrin e telefonit",
  yyyy_placeholder: "vvvv",
  date_placeholder: "dd/mm/vvvv",

  // Additional Personal Information
  address_of_residence: "Adresa e banimit",
  position_details: "Detajet e pozicionit",
  position_applied_for_label: "Pozicioni për të cilin aplikohet",
  select_position: "Zgjidh pozicionin",
  employment_type_desired: "Lloji i punësimit të dëshiruar:",
  earliest_start_date: "Disponueshmëria më e hershme për fillimin e punës",
  salary_range_expectation: "Pritshmëria për pagën",
  attachments: "Ngarko dokumentat",
  upload_cv: "Ngarko CV",
  upload_cv_description: "Ngarko CV (PDF, maksimumi 2MB)",
  upload_photo: "Ngarko foto",
  photo:"Foto",
  motivation_letter: "Letër motivimi",
  upload_motivation_letter: "Ngarko letër motivimi (Opsionale)",
  additional_information: "Informacione shtesë",
  security_background_check:
    "A jeni i gatshëm t’i nënshtroheni kontrollit të pastërtisë së figurës?",
  physical_fitness:
    "A jeni fizikisht i aftë për role që kërkojnë qëndrim në këmbë, ngritje peshe ose ecje për orë të gjata?",
  relatives_at_tia_detailed: "A keni të afërm që punojnë aktualisht në TIA?",
  relative_name: "Emri",
  name_placeholder: "emri",
  relationship: "Marrëdhënia",
  relationship_placeholder: "Marrëdhënia",
  how_learned_vacancy_detailed: "Si mësuat për vendin e lirë të punës?",
  why_applying_position: "Arsyeja e aplikimit për këtë pozicion në TIA",
  reason_for_applying: "Arsyeja e aplikimit",

  // Work Experience
  last_work_experience: "Eksperienca e fundit e punës",
  add_experience: "+ Shto eksperiencë",
  edit: "Edito",

  // Training
  training_optional_note:
    "* Ky seksion është opsional. Ju mund ta plotësoni vetëm nëse dëshironi.",
  training_title: "Titulli i trajnimit",
  place_institution_detailed: "Vendos institucionin e arsimit",
  street_city_detailed: "Rruga, qyteti",
  add_training: "+ Shto trajnim",

  // Education Additional
  driving_license: "Patentë drejtimi?",

  airport_systems_experience: "Eksperienca me sistemet e aeroportit",
  airport_systems_placeholder:
    "Eksperienca me sistemet e aeroportit (p.sh., Amadeus, SITA)",

  // Header
  form: "Formular",
  application: "Aplikimi",

  // Status and other labels
  status: "Statusi",
  selected: "Zgjedhur:",

  // File upload messages
  upload_image_or_pdf: "Ju lutem ngarkoni një imazh ose PDF.",
  file_size_error: "Madhësia e skedarit nuk duhet të kalojë 2MB.",
  cv_pdf: "CV.pdf",
  image_png: "imazh.png",

  // Success/Error messages
  form_submitted_successfully: "Formulari u dërgua me sukses!",
  submission_error: "Gabim gjatë dërgimit të formularit.",
  please_fill_all_fields: "Ju lutem plotësoni të gjitha fushat e kërkuara.",

  // Education translations
  highest_education_completed: "Niveli më i lartë i arsimit të përfunduar",
  driving_license_question: "Patentë drejtimi?",

  // Training translations
  training_optional_text:
    "* Ky seksion është opsional. Ju mund ta plotësoni vetëm nëse dëshironi.",
  training_title_label: "Titulli i trajnimit",
  institution_label: "Institucioni",
  place_label: "Vendi",

  // ComputerProgram translations
  technical_skills: "Aftësitë teknike dhe të tjera",
  computer_skills_label: "Aftësitë kompjuterike",

  // ExtraQuestion translations
  relatives_tia_question:
    "Keni të afërm që punojnë për Tirana International Airport?",
  specify_relationship_label: "Specifikoni marrëdhënien",
  how_learned_position: "Si e morët informacionin për pozicionin vakant?",

  // Declaration translations
  declaration_title: "Deklaratë",

  // File upload messages
  upload_image_pdf_error: "Ju lutem ngarkoni një imazh ose PDF.",
  file_too_large_error: "Skedari duhet të jetë më i vogjël se {size}MB.",

  // TextArea translations
  why_work_tia_default: "Përse deshironi të punoni për TIA-n?",

  // ApplicationForm translations
  application_sent_success: "Aplikimi u dërgua me sukses!",
  application_send_error: "Gabim në dërgimin e aplikimit. Provoni përsëri.",

  // JobDetails additional
  position_requirements_detail: "Kërkesat e pozicionit:",
  education_detail: "Arsimi:",
  work_experience_detail: "Eksperienca e punës:",
  language_requirements_detail: "Kërkesat e gjuhës:",
  skills_competencies_detail: "Aftësi dhe Kompetenca:",
  application_procedure_detail: "Procedura e Aplikimit",

  // Summary page additional
  type_employment_desired: "Lloji i punësimit të dëshiruar:",
  additional_certifications_summary: "Certifikime shtesë:",
  responsibilities_summary: "Përgjegjësitë:",
  reason_leaving_summary: "Arsyeja e largimit:",
  relatives_working_question: "A keni të afërm që punojnë aktualisht në TIA?",
  specify_relatives_summary: "Specifikoni të afërmit:",
  how_learned_vacancy_summary: "Si e mësuat për vendin e lirë?",

  //Sucess additional
  applicationSuccess: "Ne kemi marrë me sukses aplikimin tuaj!",
  reviewPolicy:
    "*Sipas Politikës së Rekrutimit të Brendshëm, të gjitha aplikimet do të shqyrtohen bazuar në kërkesat e pozicionit. Duke marrë parasysh numrin e madh të kandidatëve, aplikimet do të shqyrtohen sipas parimit të aplikimit të parë.",
  onlySelected:
    "*Vetëm kandidatët e përzgjedhur nga procesi i shqyrtimit të CV-ve do të kontaktohen për intervistë.",
  confidentiality:
    '*Të gjitha aplikimet do të trajtohen me konfidencialitet të plotë në përputhje me ligjin Nr. 9887 të vendosur nga Parlamenti Shqiptar për "Mbrojtjen e të Dhënave Personale".',
  explorePositions: "Kërko Pozicionet e Lira",

  // FAQs questions
  questions1_FAQs:
    "A kam nevojë për përvojë në aviacion për të aplikuar?",
  questions2_FAQs: "Cilat janë oraret dhe turnet e punës?",
  questions3_FAQs: "A mund të aplikoj për më shumë se një pozicion?",
  questions4_FAQs: "Si do të njoftohem nëse jam përzgjedhur?",

  //FAQs answers
  answers1_FAQs:
    "Jo gjithmonë. Disa pozicione kërkojnë përvojë paraprake ose kualifikime specifike, por shumë role fillestare përfshijnë mundësi trajnimi dhe zhvillimi të ofruara nga TIA. Çdo njoftim pune përcakton qartë kërkesat.",

  answers2_FAQs:
    "Aeroporti operon 24/7, ndaj shumë pozicione përfshijnë turne me rotacion, duke përfshirë turnet e natës, ditët e festave dhe ditët e pushimit. Orari i saktë varet nga roli dhe departamenti.",

  answers3_FAQs:
    "Po. Ju mund të aplikoni në disa pozicione, për aq kohë sa i plotësoni kërkesat për secilin rol.",

  answers4_FAQs:
    " Vetëm kandidatët e përzgjedhur pas procesit të shqyrtimit të CV-së do të kontaktohen nga Ekipi i Burimeve Njerëzore me detaje rreth hapave të mëtejshëm në procesin e rekrutimit.",

  //FAQs
  faqs_title: "Pyetjet e Shpeshta",


  //Testimonials
  testimonials_title: "Dëshmitë e Punonjësve",

  //Testimonials text
  testimonials_text1: "Puna në TIA më ka dhënë mundësinë të rritem profesionalisht dhe të ndihem pjesë e diçkaje më të madhe.",
  testimonials_text2: "Mjedisi i punës në ekip këtu është i jashtëzakonshëm. Çdo ditë sjell sfida të reja dhe mundësi për të mësuar.",
  testimonials_text3: "E dua faktin që jam pjesë e një ekipi që siguron udhëtime të sigurta dhe të qeta për mijëra pasagjerë çdo ditë."
  
};

export default al;
